<template>
  <v-app id="inspire" style="background: #fff !important;">

    <v-layout class="hidden-md-and-up" v-if="status_login === 'T'">
      <v-flex xs12>
        <v-toolbar dark app :clipped-left="$vuetify.breakpoint.lgAndUp" fixed class="tabss" v-if="status_login === 'T'">
          <v-toolbar-title  class="ml-0 pl-0"></v-toolbar-title>
          <div style="display: flex;">
            <span style="align-content: center; padding-top: 10px; ">
              <img src="./assets/image/logoonechat_full-white.png" style="height: 50px; border-radius: 4px;margin-left: 4vw;cursor: pointer;" @click="toPage('/#home')">
            </span>
          </div>
          <v-spacer></v-spacer>
          <!-- <v-menu offset-y>
            <v-btn icon  @click="" dark slot="activator" style="margin-left: 0px;">
              <v-badge overlap v-if="numFriendReq !== '0' && numFriendReq != ''" color="red">
                  <span slot="badge" >{{numFriendReq}}</span>
                  <v-avatar size="40"><v-icon style="color: inherit; font-size: 25px !important;">person</v-icon></v-avatar>
                </v-badge>
              <v-avatar size="40" v-else><v-icon style="color: inherit; font-size: 25px !important;">person</v-icon></v-avatar>
            </v-btn>
            <v-list style="margin-left: 0px;">
              <v-list-tile v-on:click="showDialog('AddFmo')">
                <v-icon color="gray" meduim>person_add</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">เพิ่มเพื่อน</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-on:click="showDialog('FriendSendReqDialogmo')" >
                <v-badge overlap v-if="numFriendSendReq != 0 && numFriendSendReq != ''" color="red">
                  <span slot="badge">{{numFriendSendReq}}</span>
                  <v-icon color="gray">send</v-icon>
                </v-badge>
                <v-icon color="gray" meduim>send</v-icon>
                  &nbsp;&nbsp;<v-list-tile-title class="CSChatThai">คำขอเป็นเพื่อน</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-on:click="showDialog('FriendReqDialogmo')" >
                <v-badge overlap v-if="numFriendReq !== '0' && numFriendReq != ''" color="red">
                  <span slot="badge" >{{numFriendReq}}</span>
                  <v-icon color="gray" meduim>content_paste</v-icon>
                </v-badge>
                <v-icon meduim color="gray" v-else>content_paste</v-icon>
                  &nbsp;&nbsp;<v-list-tile-title class="CSChatThai">ตอบรับเป็นเพื่อน</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-menu offset-y>
            <v-btn icon style="margin-left: 0px;margin-top: 0px;margin-right: 10px;margin-bottom: 0px;" @click="" dark slot="activator" >
              <v-badge overlap v-if="numGroupReq !== '0' && numGroupReq != ''" color="red">
                <span slot="badge" >{{numGroupReq}}</span>
                <v-avatar size="40"><v-icon style="color: inherit; font-size: 25px !important;">group</v-icon></v-avatar>
              </v-badge>
              <v-avatar  size="40" v-else><v-icon style="color: inherit; font-size: 25px !important;">group</v-icon></v-avatar>
            </v-btn>
            <v-list>
              <v-list-tile v-for="(item, index) in listMenuGroupmo" :key="index" v-on:click="showDialog(item.dialog)">
                <v-icon meduim>{{item.icon}}</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{ item.title }}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-on:click="showDialog('GroupReqmo')" >
                <v-badge overlap v-if="numGroupReq !== '0' && numGroupReq != ''" color="red">
                  <span slot="badge" >{{numGroupReq}}</span>
                  <v-icon color="gray" meduim>content_paste</v-icon>
                </v-badge>
                <v-icon meduim color="gray" v-else>content_paste</v-icon>
                  &nbsp;&nbsp;<v-list-tile-title class="CSChatThai">ตอบรับเข้ากลุ่ม</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu> -->
      <!-- <span class="textlayout" >{{myname}}</span> -->
          <div style="flex: right;">
            <v-menu bottom offset-y>
              <v-btn slot="activator" icon>
                <v-avatar size="40px" v-if="filename != ''"><img :src="filename" class="alligator-turtle">
                </v-avatar>
                <v-avatar size="40px" v-else><v-img src='/static/img/robot/developer1.png' class="alligator-turtle"/>
                </v-avatar>
              </v-btn>
              <v-list>
                <v-list-tile @click="gotoLink('/mobile/develop/profile')" >
                  <v-icon meduim>person</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">ข้อมูล API</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="gotoLink('/mobile/dev_createbot')" >
                  <v-icon meduim>create</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">สร้างบอท</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-for="(item, index) in listmenumo" :key="index" @click="showDialog(item.dialog)" >
                  <v-icon meduim>{{item.icon}}</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{ item.title }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile  v-on:click="showDialog('policydialogmo')" >
                  <v-icon meduim>book</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">นโยบายความเป็นส่วนตัว</v-list-tile-title>
                </v-list-tile>
                <v-list-tile  @click="logout()" >
                  <v-icon meduim>lock_open</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">ออกจากระบบ</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-content  v-if="status_login === 'T'" class="hidden-md-and-up" style="background-color: #fff !important;">
      <v-layout row wrap>
        <v-flex xs12 sm12 style="height: 91vh;">
          <router-view ></router-view>
        </v-flex>
      </v-layout>
    </v-content>


    <!-- <EditProfileDialog :dialogAdd="editprofile" v-on:closeFriend="closeFriend"></EditProfileDialog>
    <KeepFileDialog :dialogdAdd="keepfile" v-on:closeFriend="closeFriend"></KeepFileDialog>
    <AddDialog :dialogAdd="AddF" v-on:closeFriend="closeFriend"></AddDialog>
    <FriendReqDialog :FriendDialog="FriendReqDialog" v-on:closeFriendReq="closeFriendReq"></FriendReqDialog>
    <FriendSendReqDialog :FriendSendReqDialog="FriendSendReqDialog" v-on:closeFriendSendReq="closeFriendSendReq"></FriendSendReqDialog>
    <GropReqDialog :GroupRequest="GroupReqs" v-on:closeGroupReq="closeGroupdialog"></GropReqDialog>
    <BlockDialog :dialogBlock="block" v-on:closeFriend="closeDialogblock"></BlockDialog>
    <CreGroup :dialogGroup="CreGs" v-on:closeGroup="closeDialogCG"></CreGroup>

    <EditProfileDialogmo :dialogAdd="editprofilemo" v-on:closeFriend="closeFriend"></EditProfileDialogmo>
    <KeepFileDialogmo :dialogdAdd="keepfilemo" v-on:closeFriend="closeFriend"></KeepFileDialogmo>
    <AddDialogmo :dialogAdd="AddFmo" v-on:closeFriend="closeFriend"></AddDialogmo>
    <FriendReqDialogmo :FriendDialog="FriendReqDialogmo" v-on:closeFriendReq="closeFriendReq"></FriendReqDialogmo>
    <FriendSendReqDialogmo :FriendSendReqDialog="FriendSendReqDialogmo" v-on:closeFriendSendReq="closeFriendSendReq"></FriendSendReqDialogmo>
    <GropReqDialogmo :GroupRequest="GroupReqsmo" v-on:closeGroupReq="closeGroupdialog"></GropReqDialogmo>
    <BlockDialogmo :dialogBlock="blockmo" v-on:closeFriend="closeDialogblock"></BlockDialogmo>
    <CreGroupmo :dialogGroup="CreGsmo" v-on:closeGroup="closeDialogCG"></CreGroupmo>
    <HelpDialog :helpdialog="helpdialog" v-on:closeHelp="closeFriend"></HelpDialog> -->
    <HelpDialogMo :helpdialogmo="helpdialogmo" v-on:closeHelp="closeFriend"></HelpDialogMo>
    <!-- <FeedbackDialog :feedbackdialog="feedbackdialog" v-on:closeHelp="closeFriend"></FeedbackDialog> -->
    <FeedbackDialogmo :feedbackdialogmo="feedbackdialogmo" v-on:closeHelp="closeFriend"></FeedbackDialogmo>
    <!-- <PolicyDialog :policydialog="policydialog" v-on:closePolicy="closePolicy"></PolicyDialog> -->
    <PolicyDialogmo :policydialogmo="policydialogmo" v-on:closePolicy="closePolicy"></PolicyDialogmo>
    <!-- <EditProfilePictureDialog :dialogAdd="editprofilepic" v-on:closeFriend="closeFriend"></EditProfilePictureDialog> -->
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
// import EditProfileDialog from '@/components/chat/EditProfileDialog'
// import KeepFileDialog from '@/components/chat/KeepFileDialog'
// import AddDialog from '@/components/chat/AddDialog'
// import FriendReqDialog from '@/components/chat/FriendRequest'
// import FriendSendReqDialog from '@/components/chat/FriendSendReq'
// import GropReqDialog from '@/components/chat/GroupRequest'
// import BlockDialog from '@/components/chat/BlockFriendDialog'
// import CreGroup from '@/components/chat/CreateGroupDialog'
// import EditProfileDialogmo from '@/components/mobile/EditProfileDialog'
// import KeepFileDialogmo from '@/components/mobile/KeepFileDialog'
// import AddDialogmo from '@/components/mobile/AddDialog'
// import FriendReqDialogmo from '@/components/mobile/FriendRequest'
// import FriendSendReqDialogmo from '@/components/mobile/FriendSendReq'
// import GropReqDialogmo from '@/components/mobile/GroupRequest'
// import BlockDialogmo from '@/components/mobile/BlockFriendDialog'
// import CreGroupmo from '@/components/mobile/CreateGroupDialog'
// import LeftTool from '@/components/chat/LeftTool'
// import HelpDialog from '@/components/chat/HelpDialog'
import HelpDialogMo from '@/components/mobile/HelpDialogMo'
// import FeedbackDialog from '@/components/chat/FeedbackDialog'
import FeedbackDialogmo from '@/components/mobile/FeedbackDialogmo'
// import PolicyDialog from '@/components/chat/PolicyDialog'
import PolicyDialogmo from '@/components/mobile/PolicyDialogmo'
// import EditProfilePictureDialog from '@/components/chat/EditProfilePictureDialog'
export default {
  data: () => ({
    room: '',
    editprofilepic: false,
    policydialog: false,
    feedbackdialog: false,
    policydialogmo: false,
    feedbackdialogmo: false,
    helpdialog: false,
    helpdialogmo: false,
    keepfile: false,
    editprofile: false,
    AddF: false,
    dialog: false,
    FriendReqDialog: false,
    FriendSendReqDialog: false,
    block: false,
    CreGs: false,
    GroupReqs: false,
    keepfilemo: false,
    editprofilemo: false,
    AddFmo: false,
    dialogmo: false,
    FriendReqDialogmo: false,
    FriendSendReqDialogmo: false,
    blockmo: false,
    CreGsmo: false,
    GroupReqsmo: false,
    drawer: null,
    filename: '',
    myname: '',
    token: '',
    numGroupReq: '',
    numFriendSendReq: '',
    numFriendReq: '',
    numFriendReqSendReq: '',
    webbackend: '',
    status_login: '',
    listmenu: [
      {
        title: 'แก้ไขโปรไฟล์',
        icon: 'person',
        dialog: 'editprofile'
      },
      {
        title: 'ข้อเสนอแนะ',
        icon: 'feedback',
        dialog: 'feedbackdialog'
      },
      {
        title: 'ศูนย์ช่วยเหลือ',
        icon: 'contact_support',
        dialog: 'helpdialog'
      },
      {
        title: 'นโยบายความเป็นส่วนตัว',
        icon: 'book',
        dialog: 'policydialog'
      }

    ],
    // listMenuFriend: [
    //   {
    //     title: 'Block List',
    //     color: 'gray',
    //     icon: 'block',
    //     dialog: 'block'
    //   }
    // ],
    listMenuGroup: [
      {
        title: 'Create Group',
        icon: 'add_circle',
        dialog: 'CreGs'
      }
    ],
    listmenumo: [
      // {
      //   title: 'แก้ไขโปรไฟล์',
      //   icon: 'person',
      //   dialog: 'editprofilemo'
      // },
      // {
      //   title: 'ส่งไฟล์ไป One box',
      //   icon: 'file_upload',
      //   dialog: 'keepfilemo'
      // },
      {
        title: 'ศูนย์ช่วยเหลือ',
        icon: 'contact_support',
        dialog: 'helpdialogmo'
      },
      {
        title: 'ข้อเสนอแนะ',
        icon: 'feedback',
        dialog: 'feedbackdialogmo'
      }
    ],
    // listMenuFriendmo: [
    //   {
    //     title: 'Block List',
    //     color: 'gray',
    //     icon: 'block',
    //     dialog: 'blockmo'
    //   }
    // ],
    listMenuGroupmo: [
      {
        title: 'สร้างกลุ่ม',
        icon: 'add_circle',
        dialog: 'CreGsmo'
      }
    ]
  }),
  props: {
    source: String
  },
  methods: {
    // clickaddfriend () {
    //   // test GA on Layout
    //   console.log('mm')
    //   ga('send','event','Add Friend Conversion','Click Left Panel','Button=Add Friend')
    // },
    gotoLink (link) {
      if (link === 'logout') {
        this.logout()
      } else {
        this.$router.push(link)
      }
    },
    toPage (page) {
      this.$router.push(page)
    },
    clickservice () {
      window.open('/homepage#oneplatform', '_blank')
    },
    showDialog (dialog) {
      if (dialog === 'editprofile') {
        // ga('send','event','Edit Profile Engagement','Click Navbar','Button=Edit Profile')
        this.editprofile = true
      } else if (dialog === 'AddF') {
        // test GA on Layout
        // console.log('mm')
        // ga('send','event','Add Friend Conversion','Click Navbar','Button=Add Friend')
        this.AddF = true
      } else if (dialog === 'keepfile') {
        this.keepfile = true
      } else if (dialog === 'CreGs') {
        // console.log('mm')
        // ga('send','event','Create Group Conversion','Click Navbar','Button=Create Group')
        this.CreGs = true
      } else if (dialog === 'FriendReqDialog') {
        this.FriendReqDialog = true
      } else if (dialog === 'FriendSendReqDialog') {
        this.FriendSendReqDialog = true
      } else if (dialog === 'GroupReq') {
        this.GroupReqs = true
      } else if (dialog === 'EditF') {
        this.EditF = true
      } else if (dialog === 'block') {
        this.block = true
      } else if (dialog === 'editprofilemo') {
        this.editprofilemo = true
      } else if (dialog === 'AddFmo') {
        this.AddFmo = true
      } else if (dialog === 'keepfilemo') {
        this.keepfilemo = true
      } else if (dialog === 'CreGsmo') {
        this.CreGsmo = true
      } else if (dialog === 'FriendReqDialogmo') {
        this.FriendReqDialogmo = true
      } else if (dialog === 'FriendSendReqDialogmo') {
        this.FriendSendReqDialogmo = true
      } else if (dialog === 'GroupReqmo') {
        this.GroupReqsmo = true
      } else if (dialog === 'EditFmo') {
        this.EditFmo = true
      } else if (dialog === 'blockmo') {
        this.blockmo = true
      } else if (dialog === 'helpdialog') {
        this.helpdialog = true
      } else if (dialog === 'helpdialogmo') {
        this.helpdialogmo = true
      } else if (dialog === 'feedbackdialog') {
        this.feedbackdialog = true
      } else if (dialog === 'feedbackdialogmo') {
        this.feedbackdialogmo = true
      } else if (dialog === 'policydialog') {
        this.policydialog = true
      } else if (dialog === 'editprofilepic') {
        this.editprofilepic = true
      } else if (dialog === 'policydialogmo') {
        this.policydialogmo = true
      }
    },
    closePolicy (value) {
      this.policydialog = value
      this.policydialogmo = value
    },
    closeFriend (value) {
      this.editprofile = value
      this.editpic = value
      this.keepfile = value
      this.AddF = value
      this.editprofilemo = value
      this.editpicmo = value
      this.keepfilemo = value
      this.AddFmo = value
      this.helpdialog = value
      this.helpdialogmo = value
      this.feedbackdialog = value
      this.feedbackdialogmo = value
      this.editprofilepic = value
    },
    closeDialogEF (value) {
      this.EditF = value
      this.EditFmo = value
    },
    closeDialogblock (value) {
      this.block = value
      this.blockmo = value
    },
    closeDialogCG (value) {
      this.CreGs = value
      this.CreGsmo = value
    },
    closeFriendReq (value) {
      this.FriendReqDialog = value
      this.FriendReqDialogmo = value
    },
    closeFriendSendReq (value) {
      this.FriendSendReqDialog = value
      this.FriendSendReqDialogmo = value
    },
    closeGroupdialog (value) {
      this.GroupReqs = value
      this.GroupReqsmo = value
    },
    logout () {
      // this.$socket.emit('leavejoin', {room: localStorage.getItem('tokenuser')})
      localStorage.clear()
      // this.$router.push('/login')
      if (process.env.LogoutOneid) {
        window.open(process.env.LogoutOneid, '_parent')
      } else {
        // this.$router.push({path: '/login', force: true})
        this.$router.push('/login')
      }
      // this.$socket.emit('leave', {room: this.token})
      // this.$socket.emit('disconnect')
    },
    policy () {
      // this.$router.push('/policy')
      window.open('/policy', '_blank')
    }
  },
  components: {
    // EditProfileDialog,
    // KeepFileDialog,
    // AddDialog,
    // CreGroup,
    // FriendReqDialog,
    // GropReqDialog,
    // FriendSendReqDialog,
    // BlockDialog,
    // EditProfileDialogmo,
    // KeepFileDialogmo,
    // AddDialogmo,
    // CreGroupmo,
    // FriendReqDialogmo,
    // GropReqDialogmo,
    // FriendSendReqDialogmo,
    // BlockDialogmo,
    // LeftTool,
    // HelpDialog,
    HelpDialogMo,
    // FeedbackDialog,
    FeedbackDialogmo,
    // PolicyDialog,
    PolicyDialogmo
    // EditProfilePictureDialog
  },
  computed: {
    ...mapState({
      myprofile: 'myprofile',
      sendrequest: 'sendrequest',
      request: 'request',
      groupreq: 'groupreq'
    })
  },
  watch: {
    myprofile () {
      this.filename = localStorage.getItem('profilepicture')
      this.myname = localStorage.getItem('name')
    },
    request () {
      this.$http.post(process.env.APImanage + '/web/getlistrequestfriend', {tokenuser: this.token}).then((response) => {
        // this.FriendReq = response.body['listrequestfriend']
        this.numFriendReq = response.body['listrequestfriend'].length
        localStorage.setItem('numFriendReq', response.body['listrequestfriend'].length)
      })
    },
    groupreq () {
      this.$http.post(process.env.APImanage + '/web/getlistpendinggroup', {tokenuser: this.token}).then((response) => {
        // this.GroupReq = response.body['listpendinggroup']
        this.numGroupReq = response.body['listpendinggroup'].length
        localStorage.setItem('numGroupReq', response.body['listpendinggroup'].length)
      })
    }
  },
  created () {
    // Vue.use(VueSocketio, localStorage.getItem('ipsocket'))
    // Vue.use(VueSocketio, io(localStorage.getItem('ipsocket'), {
    //   'secure': true,
    //   'transports': ['websocket'],
    //   'reconnect': true,
    //   'reconnection delay': 500,
    //   'max reconnection attempts': 10
    // }))
    // this.token = localStorage.getItem('tokenuser')
    this.room = this.$router.currentRoute.path
    this.webbackend = process.env.API
    this.token = localStorage.getItem('tokenuser')
    // this.$socket.emit('join', {room: localStorage.getItem('tokenuser')})
    // this.$socket.emit('connect')
    // console.log(this.$socket.emit('connect'))
    this.filename = localStorage.getItem('profilepicture')
    this.myname = localStorage.getItem('name')
    this.numGroupReq = localStorage.getItem('numGroupReq')
    this.numFriendReq = localStorage.getItem('numFriendReq')
    this.status_login = localStorage.getItem('status_login')
  }
}
</script>
<style type="text/css" scoped>
  b {
    font-weight: 900 !important;

  }

.tabss{
  background-color: #2562af !important;
}
.tabssright{
  background-color: #2562af !important;
}
.tabs__bar .icon--right {
    right: 10px !important;
}
.tabs__bar .icon--left {
    left: 10px !important;
}

.tabs:not(.tabs--grow):not(.tabs--mobile) .tabs__item {
    padding: 0 15px !important;
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.text {
  white-space: nowrap;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
  padding-top: 0px;
  font-family: 'CS ChatThaiUI' !important;
}
.textlayout {
  white-space: nowrap;
  width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 0vw;
  padding-top: 1vh;
  padding-left: 2vw;
  font-family: 'CS ChatThaiUI' !important;
  font-size: 18px;
  padding-bottom: 0px;
  color: white;
  text-transform: none;
}
span.badge__bage.red {
  left: 27px;
}
.icon {
  font-size: 25px!important;
}
.badge--overlap .badge__badge {
  top: -12px;
  right: -9px;
}
.application .theme--light.list .list__tile:not(.list__tile--active), .theme--light .list .list__tile:not(.list__tile--active) {
  padding: 2vw !important;
}
/*.application .theme--light.list, .theme--light .list {
  padding: 2vw !important;
}*/
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.listmenuweb {
  padding-left: 8px !important;
}
.list {
  padding-left: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Layoutmo.vue